import axiosInstance from '../axiosInstance';

export const transactionApi = {
    post: (path, params, cancelToken) =>
        axiosInstance
            .post(`/transaction${path}`, params, {
                cancelToken: cancelToken?.token
            })
            .then((res) => {
                if (res?.data?.error) throw res.data;
                return res?.data;
            })
            .catch((err) => {
                throw err.error ? err : err?.response?.data;
            }),
    get: (path, params, cancelToken) =>
        axiosInstance
            .get(`/transaction${path}`, params, {
                cancelToken: cancelToken?.token
            })
            .then((res) => {
                if (res?.data?.error) throw res.data;
                return res?.data;
            })
            .catch((err) => {
                throw err.error ? err : err?.response?.data;
            })
};

export const getTransaction = async (params) => transactionApi.post('/gettransaction', params);

export const saveTransaction = async (params) => transactionApi.post('/savetransaction', params);

export const createTransaction = async (params) => transactionApi.post('/createpayment', params);

export const executeTransaction = async (params) => transactionApi.post('/executepayment', params);

export const createPayPalCompetitionOrder = async (params) => transactionApi.post('/createpaypalcompetitionorder', params);

export const capturePayPalCompetitionOrder = async (params) => transactionApi.post('/capturepaypalcompetitionorder', params);
